// Three layers, each with its own switch saved in localStorage: the soundtrack (Chris Tilton), the city (harbour
// waves, traffic, gulls and ship horns, all made in WebAudio) and the HUD's casino sounds. Browsers only allow audio
// after a tap, so whatever is switched on starts on the first tap or key press.
import { useSyncExternalStore } from "react";
import { startCity, stopCity } from "./city";
import { play } from "./sfx";

const KEY = "xf_audio";
export const ARTIST = "Chris Tilton";
export const TRACKS = [
  { src: "/music/population.mp3", title: "Population, Pt. 1" },
  { src: "/music/foundation.mp3", title: "Building the Foundation" },
  { src: "/music/decade.mp3", title: "All in a Decade's Work" },
];
const MUSIC_VOL = 0.45;

let state = { music: true, city: true, sfx: true, playing: false, track: Math.floor(Math.random() * TRACKS.length),
  ...JSON.parse(localStorage.getItem(KEY) || "{}"), unlocked: false };
state.playing = false;
const subs = new Set();
const set = (patch) => {
  state = { ...state, ...patch };
  localStorage.setItem(KEY, JSON.stringify({ music: state.music, city: state.city, sfx: state.sfx, track: state.track }));
  subs.forEach((f) => f());
};

let el, fader;
function fade(to, then) {
  clearInterval(fader);
  fader = setInterval(() => {
    const v = el.volume + Math.sign(to - el.volume) * 0.03;
    if (Math.abs(to - el.volume) <= 0.03) {
      el.volume = to;
      clearInterval(fader);
      then?.();
    } else el.volume = Math.min(1, Math.max(0, v));
  }, 40);
}

function startMusic() {
  if (!el) {
    el = new Audio();
    el.preload = "none";
    el.onended = () => next();
  }
  const src = TRACKS[state.track].src;
  if (!el.src.endsWith(src)) el.src = src;
  el.volume = 0;
  el.play().then(() => { set({ playing: true }); fade(MUSIC_VOL); }).catch(() => set({ playing: false }));
}

function stopMusic() {
  set({ playing: false });
  if (el) fade(0, () => el.pause());
}

export function toggleMusic() {
  const on = !state.playing;
  set({ music: on });
  if (!state.unlocked) unlock();
  else on ? startMusic() : stopMusic();
}

export function next() {
  set({ track: (state.track + 1) % TRACKS.length });
  if (el) el.src = TRACKS[state.track].src;
  if (!state.unlocked) unlock();
  else if (state.music) startMusic();
}

export function toggleCity() {
  set({ city: !state.city });
  if (!state.unlocked) unlock();
  else state.city ? startCity() : stopCity();
}

export function toggleSfx() {
  set({ sfx: !state.sfx });
  unlock();
  if (state.sfx) play("click");
}

export function sfx(kind) {
  if (state.sfx && state.unlocked) play(kind);
}

export const useAudio = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);

// The first tap starts everything that is switched on. Taps on the deck are left to its own buttons: starting the
// music on pointerdown and then letting the Play button's click flip it would pause it again.
function unlock(e) {
  if (state.unlocked || e?.target.closest?.("[data-testid=sound-deck]")) return;
  set({ unlocked: true });
  if (state.music) startMusic();
  if (state.city) startCity();
}
window.addEventListener("pointerdown", unlock);
window.addEventListener("keydown", unlock);
